// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalList_header__GrSNv","modalList":"ModalList_modalList__50eil"};